import CalCalDataApi from '../../api/CalCalDataApi';

export function loadPreviews() {
	//should load for the specific taxyear??
	return function(dispatch, getState) {
		const jwt = getState().loginReducer.jwt.token; //expiresd?

		CalCalDataApi.dataLoad('reports', jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (!res.error) {
				console.log(res);
				dispatch({
					type: 'REPORTS_LOADED',
					entries: res
				});
			} else {
				dispatch({
					type: 'REPORTS_ERROR',
					error: res.error
				});
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	};
}

export function loadReport(report, filter) {
	return function(dispatch, getState) {
		const jwt = getState().loginReducer.jwt.token;
		const { minDate, maxDate } = filter;
		const dates = minDate && maxDate ? '/' + minDate + ':' + maxDate : '';
		//should dispatch report_loaded with the report name.
		console.log('loadReport', report);
		CalCalDataApi.dataLoad('reports/' + report + dates, jwt, res => {
			if (__DEV__) console.log(res);
			if (!res.error) {
				dispatch({
					type: 'REPORT_LOADED',
					report,
					data: res
				});
			}
		});
	};
}

export function loadFilters() {
	return function(dispatch, getState) {
		const jwt = getState().loginReducer.jwt.token;
		CalCalDataApi.dataLoad('reports/filters', jwt, res => {
			//dispatch({type: 'CUSTOMERS_IS_LOADING', isLoading: false});
			if (!res.error) {
				//console.log(res);
				dispatch({
					type: 'REPORTS_FILTERS_LOADED',
					filters: res
				});
			} else {
				console.warn(res);
				dispatch({
					type: 'REPORTS_ERROR',
					error: res.error
				});
				if (res.error == 'Expired token')
					dispatch({
						type: 'SET_JWT',
						token: null,
						info: null
					});
			}
		});
	};
}

/*

eg

// Thunk function, it calls the getRepos action above after it receives the fetch response.
export function getRepoThunk() {
  return function(dispatch, getState) {
    fetch('https://api.github.com/repositories')
    .then(e => e.json())
      .then(function(response){
        console.log(response);
        var arr = response.slice(0,10);
        dispatch(getRepos(arr))
      })
      .catch((error) => {
        console.error(error,"ERRRRRORRR");
      });
  }
}
// Repo selected action
export function repoSelected(repo){
  return{
    type: 'Repo_Selected',
    payload: repo
  }
}

*/
